/**
 * General Settings Tab - Name, short code, icon, color, active toggle
 */

import React from 'react';
import type { CustomMarketplace } from '../types';

interface GeneralSettingsTabProps {
  selectedMarketplace: CustomMarketplace;
  setSelectedMarketplace: (mp: CustomMarketplace) => void;
}

const GeneralSettingsTab: React.FC<GeneralSettingsTabProps> = ({
  selectedMarketplace,
  setSelectedMarketplace,
}) => {
  return (
    <div className="space-y-6">
      <div className="grid grid-cols-2 gap-6">
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1">
            Pazaryeri Ad&#x131;
          </label>
          <input
            type="text"
            value={selectedMarketplace.name}
            onChange={(e) => setSelectedMarketplace({ ...selectedMarketplace, name: e.target.value })}
            className="w-full px-3 py-2 border border-slate-200 rounded-lg focus:ring-2 focus:ring-indigo-500"
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1">
            K&#x131;sa Kod
          </label>
          <input
            type="text"
            value={selectedMarketplace.shortName}
            onChange={(e) => setSelectedMarketplace({ ...selectedMarketplace, shortName: e.target.value.toUpperCase() })}
            className="w-full px-3 py-2 border border-slate-200 rounded-lg focus:ring-2 focus:ring-indigo-500"
            maxLength={5}
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1">
            &#x130;kon (Emoji)
          </label>
          <input
            type="text"
            value={selectedMarketplace.icon}
            onChange={(e) => setSelectedMarketplace({ ...selectedMarketplace, icon: e.target.value })}
            className="w-full px-3 py-2 border border-slate-200 rounded-lg focus:ring-2 focus:ring-indigo-500"
            maxLength={2}
          />
        </div>
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1">
            Tema Rengi
          </label>
          <div className="flex gap-2">
            <input
              type="color"
              value={selectedMarketplace.color}
              onChange={(e) => setSelectedMarketplace({ ...selectedMarketplace, color: e.target.value })}
              className="w-12 h-10 border border-slate-200 rounded cursor-pointer"
            />
            <input
              type="text"
              value={selectedMarketplace.color}
              onChange={(e) => setSelectedMarketplace({ ...selectedMarketplace, color: e.target.value })}
              className="flex-1 px-3 py-2 border border-slate-200 rounded-lg focus:ring-2 focus:ring-indigo-500"
            />
          </div>
        </div>
      </div>

      <div className="flex items-center gap-3 pt-4 border-t border-slate-200">
        <label className="flex items-center gap-2 cursor-pointer">
          <input
            type="checkbox"
            checked={selectedMarketplace.isActive}
            onChange={(e) => setSelectedMarketplace({ ...selectedMarketplace, isActive: e.target.checked })}
            className="w-4 h-4 text-indigo-600 border-slate-300 rounded focus:ring-indigo-500"
          />
          <span className="text-sm text-slate-700">Aktif</span>
        </label>
      </div>
    </div>
  );
};

export default GeneralSettingsTab;
